import { Box, useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";

export const ServicesHeader = () => {
  const isMobile = useMediaQuery("(max-width:800px)");
  const { t } = useTranslation();

  return (
    <Box
      sx={{ display: "flex" }}
      style={{ display: isMobile ? "block" : "flex" }}
      className="servicesHeader"
    >
      <Box
        sx={{
          width: { xs: "100%", sm: "35%", md: "35%", lg: "35%" },
        }}
      >
        <h2>{t("services_header_title")}</h2>
      </Box>
      <Box sx={{ width: { xs: "100%", sm: "30%" } }}>
        <h1>{t("services_header_subtitle")}</h1>
      </Box>
    </Box>
  );
};
